import type {
  AnalyticsPageEventName,
  LinkMouseEvent,
  SocialLinkEventLabels,
} from "./types";

import { useSegmentAnalytics } from "./useSegmentAnalytics";

export const useGlobalAnalytics = () => {
  const { trackButtonClickEvent, trackLinkClickEvent, trackPageEvent } =
    useSegmentAnalytics();

  const analyticsPageMap: Record<string, AnalyticsPageEventName> = {
    "/": "Overview",
    "/leads": "Leads",
    "/clients": "Clients",
    "/earnings": "Earnings",
    "/marketing": "Marketing",
    "/performance": "Performance",
    "/triage": "Triage",
    "/triage/history": "TriageHistory",
    "/triage/mam": "TriageMAM",
    "/inactivity-logout": "Inactivity logout",
  };

  const trackLaunchPersonalTradingHeaderEvent = (event: LinkMouseEvent) => {
    trackLinkClickEvent({
      event,
      label: "Launch personal trading",
      location: "Header",
    });
  };
  const trackLaunchPersonalTradingProfileMenuEvent = (
    event: LinkMouseEvent,
  ) => {
    trackLinkClickEvent({
      event,
      label: "Launch personal trading",
      location: "Profile menu",
    });
  };

  const trackMAMProfileMenuEvent = (event: LinkMouseEvent) =>
    trackLinkClickEvent({ event, label: "MAM", location: "Profile menu" });
  const trackViewProfileProfileMenuEvent = (event: LinkMouseEvent) =>
    trackLinkClickEvent({
      event,
      label: "View profile",
      location: "Profile menu",
    });
  const trackWithdrawProfileMenuEvent = (event: LinkMouseEvent) =>
    trackLinkClickEvent({ event, label: "Withdraw", location: "Profile menu" });
  const trackTransferProfileMenuEvent = (event: LinkMouseEvent) =>
    trackLinkClickEvent({ event, label: "Transfer", location: "Profile menu" });
  const trackCompleteApplicationProfileMenuEvent = (event: LinkMouseEvent) =>
    trackLinkClickEvent({
      event,
      label: "Complete application",
      location: "Profile menu",
    });
  const trackSocialLinkProfileMenuEvent = (
    event: LinkMouseEvent,
    label: SocialLinkEventLabels,
  ) =>
    trackLinkClickEvent({
      event,
      label,
      location: "Profile menu social links",
    });
  const trackSocialLinkFooterEvent = (
    event: LinkMouseEvent,
    label: SocialLinkEventLabels,
  ) =>
    trackLinkClickEvent({
      event,
      label,
      location: "Footer social links",
    });

  const trackLanguageSelectorHeaderEvent = (languageLabel: string) =>
    trackButtonClickEvent({
      location: "Header",
      label: `Language - ${languageLabel}`,
    });
  const trackLanguageSelectorMobileMenuEvent = (languageLabel: string) =>
    trackButtonClickEvent({
      location: "Header mobile menu",
      label: `Language - ${languageLabel}`,
    });

  const trackNavigationHeaderEvent = (event: LinkMouseEvent, label: string) => {
    trackLinkClickEvent({ event, label, location: "Header" });
  };
  const trackNavigationMobileMenuEvent = (
    event: LinkMouseEvent,
    label: string,
  ) => {
    trackLinkClickEvent({ event, label, location: "Header mobile menu" });
  };

  return {
    analyticsPageMap,
    trackPageEvent,
    trackLaunchPersonalTradingHeaderEvent,
    trackLaunchPersonalTradingProfileMenuEvent,
    trackMAMProfileMenuEvent,
    trackViewProfileProfileMenuEvent,
    trackWithdrawProfileMenuEvent,
    trackTransferProfileMenuEvent,
    trackCompleteApplicationProfileMenuEvent,
    trackSocialLinkProfileMenuEvent,
    trackSocialLinkFooterEvent,
    trackLanguageSelectorHeaderEvent,
    trackLanguageSelectorMobileMenuEvent,
    trackNavigationHeaderEvent,
    trackNavigationMobileMenuEvent,
  };
};
